import { Block } from "baseui/block";
import { Card, StyledBody } from "baseui/card";
import { Tab, Tabs } from "baseui/tabs-motion";
import { useEffect, useState } from "react";
import { IAddEventState } from "./AddEventDialog";
import { StateVariable } from "../../../../utils/stateVariable";
import FlexDateForm from "./FlexDateForm";
import { addDays } from "date-fns";
import { FlexDate } from "../types";
import { useIntl, FormattedMessage } from 'react-intl';

export interface IAddEventFormProps {
    value: StateVariable<IAddEventState>,
}


const AddEventForm = (props: IAddEventFormProps) => {
    const intl = useIntl();

    const [date, setDate] = useState<FlexDate>({ date: new Date(), evenMonths: false, flexDay: false, flexMonth: false, flexYear: false, oddMonths: false });
    const [drStart, setDrStart] = useState<FlexDate>({ date: addDays(new Date(), -1), evenMonths: false, flexDay: false, flexMonth: false, flexYear: false, oddMonths: false });
    const [drEnd, setDrEnd] = useState<FlexDate>({ date: new Date(), evenMonths: false, flexDay: false, flexMonth: false, flexYear: false, oddMonths: false });
    const [activeKey, setActiveKey] = useState<React.Key>('0');

    const flexDateState: StateVariable<FlexDate> = { value: date, setValue: setDate };
    const flexDateRageStartState: StateVariable<FlexDate> = { value: drStart, setValue: setDrStart };
    const flexDateRageEndState: StateVariable<FlexDate> = { value: drEnd, setValue: setDrEnd };

    // update HOC state
    useEffect(() => {
        if (activeKey === '0') {
            props.value.setValue((prevState) => ({
                ...prevState,
                date: date,
                dateRange: undefined,
            }))
        }
    }, [date, activeKey]);
    // update HOC state
    useEffect(() => {
        if (activeKey === '1') {
            props.value.setValue((prevState) => ({
                ...prevState,
                date: undefined,
                dateRange: { start: drStart, end: drEnd }
            }))
        }
    }, [drStart, drEnd, activeKey]);

    return (
        <Block display='flex' flexDirection='column' width='100%' gridGap='20px'>
            <Tabs
                activeKey={activeKey}
                onChange={({ activeKey }) => {
                    setActiveKey(activeKey);
                }}
                activateOnFocus
            >
                <Tab title={intl.formatMessage({ id: "date", defaultMessage: "Date" })}>
                    <FlexDateForm value={flexDateState}></FlexDateForm>
                </Tab>
                <Tab title={intl.formatMessage({ id: "dateRange", defaultMessage: "Date Range" })}>
                    <Block display='flex' flexDirection='row' gridGap='20px'>
                        <Card title={intl.formatMessage({ id: "from", defaultMessage: "From" })}>
                            <StyledBody>
                                <FlexDateForm value={flexDateRageStartState}></FlexDateForm>
                            </StyledBody>
                        </Card>
                        <Card title={intl.formatMessage({ id: "to", defaultMessage: "To" })}>
                            <StyledBody>
                                <FlexDateForm value={flexDateRageEndState}></FlexDateForm>
                            </StyledBody>
                        </Card>
                    </Block>
                </Tab>
            </Tabs>
        </Block>
    );


};

export default AddEventForm;